<template>
 <div class="flex-col bottom_section_2">
    <img
    src="@/assets/imgs/logoW.svg"
    class="image_1"
  />
  <img
    src="@/assets/imgs/16532917813426533006.png"
    class="image_2"
  />
  <div class="flex-col button">
    <div class="section_3"><!--*--></div>
    <span class="text_22">服务热线：{{ phone }}</span>
  </div>
  <div class="group_13">
    <span class="text_23"><a :href="icpUrl" target="_blank">{{ icp }}</a></span>
    <span class="text_23 email">邮箱 {{ email }}</span>
    <span class="text_23"> {{ address }} </span>
    <span class="text_23">Copyright© {{ new Date().getFullYear() }} {{ companyName }}</span>
  </div>
</div>
</template>

<script>
import { getfoot } from '@/api/nav.js'
export default {
  data() {
    return {
      companyName: '',
      record: '',
      phone: '',
      icp: '',
      address: '',
      email:'',
      icpUrl:''
    };
  },
  mounted () {
    getfoot({ dictType: 'global' }).then(res => {
        res.data.forEach(item => {
          if (item.dictName === 'icp') {
            this.icp = item.title
          } else if (item.dictName === 'hot_line') {
            this.phone = item.title
          } else if (item.dictName === 'company_name') {
            this.companyName = item.title
          } else if (item.dictName == 'address') {
            this.address = item.title
          }else if(item.dictName=='2b59ff18-1885-4318-94b8-57f58831f7c2'){
            this.email=item.link
          }else if(item.dictName=='40d6b15e-9397-488f-99e3-3af0f4d4be33'){
            this.icpUrl=item.link
          }
        })
      })
  },
  watch: {
  },
};
</script>

<style lang="less" scoped>
.bottom_section_2 {
  padding: .8rem .93rem .87rem;
  background-color: #131931;
  .image_1 {
    align-self: center;
    width: 6.9467rem;
    height:.88rem;
  }
  .image_2 {
    margin-top: .1rem;
    align-self: center;
    width: 4rem;
  }
  .button {
    margin-top: .88rem;
    position: relative;
    .section_3 {
      opacity: 0.4;
      height: 1rem;
      border: solid .975px #ffffff;
    }
    .text_22 {
      color: #ffffff;
      font-size: .4rem;
      line-height: .41rem;
      position: absolute;
      left: 1.52rem;
      top: 50%;
      transform: translateY(-50%);
    }
  }
  .group_13 {
    margin-top: .6333rem;
    align-self: center;
    text-align: center;
    .text_23 {
      display: block;
      color: #ffffff;
      font-size: .2933rem;
      line-height: .5333rem;
      opacity: 0.8;
      a{
        color: #ffffff;
      }
    }
  }
}
</style>
